import { render, staticRenderFns } from "./page-section.global.vue?vue&type=template&id=6b0582fd&"
import script from "./page-section.global.vue?vue&type=script&lang=js&"
export * from "./page-section.global.vue?vue&type=script&lang=js&"
import style0 from "./page-section.global.vue?vue&type=style&index=0&id=6b0582fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports